import _ from 'lodash';

export default function selector(storeState) {
    return {
        orgTimezone: _.get(storeState, 'profile.organizationTimezone', 'UTC'),
    };
}
